import { persons, parties } from "../../../mocks/gossip";

export default function PersonSection() {
  return (
    <section id="persons" className="bg-[#f1e6d6]">
      <div className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="inline-flex items-center gap-2 text-sm font-semibold tracking-wide text-[#8a5a20]">
              <span className="h-px w-6 bg-[#8a5a20]"></span>人物与关联方
            </p>
            <h2 className="mt-3 font-serif-sc text-3xl font-black text-[#2a2320] md:text-4xl">核心人物档案</h2>
          </div>
          <a
            href="#graph"
            className="inline-flex items-center gap-1 text-sm whitespace-nowrap text-[#8a5a20] transition hover:text-[#b4372a]"
          >
            回看连线关系 <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {persons.map((p) => (
            <article key={p.id} className="flex flex-col rounded-lg border border-[#eadccb] bg-white p-5">
              <div className="flex items-center gap-3">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#b4372a] font-serif-sc text-lg font-bold text-white">
                  {p.initials}
                </span>
                <div>
                  <h3 className="font-serif-sc text-lg font-bold text-[#2a2320]">{p.name}</h3>
                  <span className="text-xs text-[#b98a2f]">{p.role}</span>
                </div>
              </div>
              <p className="mt-4 flex-1 text-sm leading-relaxed text-[#7a6f66]">{p.summary}</p>
              <div className="mt-4 flex flex-wrap gap-1.5">
                {p.tags.map((t) => (
                  <span
                    key={t}
                    className="rounded-full bg-[#f7e4d6] px-2.5 py-1 text-xs text-[#98301f]"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>

        <h3 className="mt-14 font-serif-sc text-2xl font-bold text-[#2a2320]">关联方 / 机构</h3>
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {parties.map((p) => (
            <article
              key={p.id}
              className="flex gap-4 rounded-lg border border-[#eadccb] bg-white p-5 transition hover:border-[#d9a06b]"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-[#b98a2f]/15 text-[#9a701f]">
                <i className="ri-building-2-line text-xl" aria-hidden="true"></i>
              </span>
              <div>
                <h4 className="font-bold text-[#2a2320]">{p.name}</h4>
                <span className="text-xs text-[#b98a2f]">{p.kind}</span>
                <p className="mt-2 text-sm leading-relaxed text-[#7a6f66]">{p.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}